// extracted by mini-css-extract-plugin
export var chip = "_qy-2";
export var chipBody = "_qy-8";
export var chipHeader = "_qy-9";
export var chipWithKind = "_qy-7";
export var icon = "_qy-3";
export var kind = "_qy-a";
export var remove = "_qy-5";
export var removeIcon = "_qy-6";
export var row = "_qy-0";
export var rowHistorical = "_qy-1";
export var text = "_qy-4";